const sidebarNav = [
    {
        link: '/',
        section: 'home',
        icon: <i className='bx bx-home-alt'></i>,
        text: 'Home'
    },
    {
        link: '/addbook',
        section: 'Add a Book',
        icon: <i className='bx bx-book' ></i>,
        text: 'Add a Book'
    },
    {
        link: '/books-stall',
        section: 'BooksStall',
        icon: <i className='bx bx-library' ></i>,
        text: 'Books'
    },
    {
        link: '/checkout',
        section: 'Checkout',
        icon: <i className='bx bx-arrow-from-left'></i>,
        text: 'Checkout'
    }
]

export default sidebarNav;